
    var riot = require('riot')
    import { Results } from './gb-results';
riot.tag2('gb-results', '<yield> <gb-list items="{$productable.records}" item-alias="product"> <gb-product all-meta="{$product.allMeta}" lazy="{$product.lazy}"></gb-product> </gb-list> </yield>', 'gb-results.gb-stylish gb-list,[data-is="gb-results"].gb-stylish gb-list{ padding: 0; list-style: none; display: flex; flex-wrap: wrap; justify-content: space-around; } gb-results.gb-stylish gb-product,[data-is="gb-results"].gb-stylish gb-product{ display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; }', '', function(opts) {
    this._mixin(Results);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/results/gb-results.tag.html